import React from 'react';
import Slider from 'src/components/slider';
import styles from './userRoleDetailView.module.scss';
import Button from 'src/components/button';


const DeleteUserRoleDialog = ({ name, onConfirm, onCancel, show} ) => {
  return (
    <Slider.Dialog
      show={show}
      width="300"
      title="Deleting..."
      onClose={onCancel}  
      className={styles.deleteConfirmDialog}            
    >
      <Slider.Body>
        <p className={styles.description}>
          Users assigned to this role will fall back to the 'Normal User' role upon deletion.
        </p>

      </Slider.Body>

      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text="Confirm"
          variant="primary"
          onClick={onConfirm}
        />
        <Button
          text="Cancel"
          variant="secondary"
          onClick={onCancel}
        />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteUserRoleDialog;
